import React, { Component } from 'react';
import { ReactComponent as GoogleLogoSvg } from 'app/assets/logos/google-cloud-logo.svg';

export default class GoogleLogo extends Component {
  render() {
    const { iconSize, color, ...props } = this.props;
    return <GoogleLogoSvg {...props} />;
  }
}
